import React from "react";
import "./WhyChooseUs.css";

const data = [
  { icon: "✔️", title: "Same Day Service" },
  { icon: "👨‍🔧", title: "Certified Technicians" },
  { icon: "🛡️", title: "Genuine Parts" },
  { icon: "📞", title: "24/7 Support" },
];

const WhyChooseUs = () => {
  return (
    <section className="why-section">
      <h2>Why Choose Us?</h2>

      <div className="why-grid">
        {data.map((item, index) => (
          <div className="why-card" key={index}>
            <div className="why-icon">{item.icon}</div>
            <p>{item.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
